import { createAsyncThunk } from "@reduxjs/toolkit";
import { useHttp } from "../../hooks/http.hook";

export const fetchNewsInfo = createAsyncThunk(
  "newsInfo/fetchNewsInfo",
  async (query) => {
    const { request } = useHttp();
    const dataLang = localStorage.getItem("dataLang");
    const shortNameParam = dataLang
      ? `?lang=${JSON.parse(dataLang).shortName}`
      : "";
    let url = `api/news/${window.env.PROJECT_ID}/${shortNameParam}`;

    if (Object.hasOwn(query, "categoryId")) {
      url += `&categoryId=${query.categoryId}`;
    }
    if (Object.hasOwn(query, "top")) {
      url += `&top=${query.top}`;
    }
    if (Object.hasOwn(query, "skip")) {
      url += `&skip=${query.skip}`;
    }

    const { json } = await request(url, "GET");
    return await new Promise((resolve) => resolve(json));
  }
);
